import React, { useEffect, useState } from 'react';
import { LinearProgress } from '@material-ui/core';
import { useAppDispatch } from '../../../../../../hooks';
import { clearForm } from '../../../../../../state/ui/forms';
import {
    activatePreview,
    closePreview,
    fetchTasks,
} from '../../../../../../state/_actions';
import {
    useCreatorLevel,
    useGridSnapshot,
    useIncludedNotPlanned,
    useOnlyNotAssigned,
    useOnlyNotPlanned,
    usePane,
    useSourceSetDates,
} from '../../../../selectors/index.hooks';
import { DiscoveryTaskShowEventButton } from './DiscoveryTaskShowEventButton';
import { useTask } from '../../../../selectors/composed/index.hooks';
import { showTaskModificationDialog } from '../../../../../../state/ui/dialog';
import { useAddLocation } from './hooks/useAddLocation';
import { sourceSetIds } from '../../../../../../state/types';
import TaskPreview from '../../../../../../features/TaskForm/components/TaskPreview';
import PreviewReports from '../../../PreviewReports';

const TaskPane = () => {
    const pane = usePane();
    const dispatch = useAppDispatch();
    const mode = pane?.mode;
    const task = useTask();

    const creatorLevel = useCreatorLevel();
    const handleCloseClick = () => {
        dispatch(clearForm({ type: 'task' }));
        dispatch(closePreview(creatorLevel));
    };
    const handleAddLocation = useAddLocation();
    const sourceSetDates = useSourceSetDates();
    const gridSnapshot = useGridSnapshot();
    const onlyNotPlanned = useOnlyNotPlanned();
    const onlyNotAssigned = useOnlyNotAssigned();

    const [shouldShowDialog, setShouldShowDialog] = useState(false);

    const includeNotPlanned = useIncludedNotPlanned();

    useEffect(() => {
        if (task && shouldShowDialog && gridSnapshot.sourceSetId === 'tasks') {
            dispatch(
                showTaskModificationDialog({
                    taskId: task._meta.header.task.id,
                    onSuccess: handleFetchTasks,
                    handleAddLocation,
                    dates: sourceSetDates,
                    mode: 'edit',
                })
            );
            setShouldShowDialog(false);
        }
    }, [shouldShowDialog, gridSnapshot]);

    const handleFetchTasks = () => {
        if (!sourceSetDates) {
            return;
        }
        const fetchTasksParams = () => {
            return onlyNotPlanned
                ? {
                      onlyNotAssigned,
                      includeNotPlanned: true,
                  }
                : {
                      from: sourceSetDates.from,
                      to: sourceSetDates.to,
                      onlyNotAssigned,
                      includeNotPlanned,
                  };
        };
        dispatch(fetchTasks(fetchTasksParams()));
    };
    const handleChangeMode = () => {
        dispatch(
            activatePreview(
                sourceSetIds.tasks,
                task?.id || '',
                'task',
                'preview',
                {
                    type: 'preview',
                    level: creatorLevel,
                }
            )
        );
        setShouldShowDialog(true);
    };
    const rightControls = () => {
        return (
            <>
                <DiscoveryTaskShowEventButton />
            </>
        );
    };
    switch (mode) {
        case 'preview':
            return (
                <TaskPreview
                    pane={pane}
                    onClose={handleCloseClick}
                    rightControls={rightControls}
                    task={task}
                    handleChangeMode={handleChangeMode}
                    refetchGridsData={handleFetchTasks}
                    handleAddLocation={handleAddLocation}
                    reportChildren={
                        <PreviewReports reports={task?.reports || null} />
                    }
                />
            );
        default:
            return <LinearProgress />;
    }
};

export default TaskPane;
